import { IMergeTag } from '@opengov/stories-shared/types';
import { Button, ListItemText, Menu, MenuItem, Tooltip } from '@mui/material';
import React, { useState } from 'react';
import { styles } from './MergeTagsDropdown.styles';

export type IMergeTagsDropdownProps = {
  mergeTagList: IMergeTag[];
  disabled: boolean;
  disabledTooltipText?: string;
  onClick(mergeTag: IMergeTag): void;
};

export const MergeTagsDropdown = ({ mergeTagList, disabled, disabledTooltipText, onClick }: IMergeTagsDropdownProps) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchor(event.currentTarget);
  };

  const handleClose = () => {
    setAnchor(null);
  };

  return (
    <>
      <Tooltip title={disabledTooltipText ?? ''} disableHoverListener={!disabled}>
        <span>
          <Button
            size="small"
            disabled={disabled}
            onClick={handleOpen}
            data-test="merge-tags-dropdown"
            className="merge-tags-dropdown-button"
          >
            {'{ }'}
          </Button>
        </span>
      </Tooltip>
      <Menu
        id="merge-tags-dropdown"
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={handleClose}
        MenuListProps={{ disablePadding: false }}
        PaperProps={{ sx: styles.menuPaper }}
      >
        {mergeTagList.map((mergeTag) => (
          <MenuItem
            key={mergeTag.id}
            data-test={`merge-tags-dropdown-option-${mergeTag.id}`}
            onClick={() => {
              onClick(mergeTag);
              handleClose();
            }}
          >
            <ListItemText
              primary={mergeTag.label}
              secondary={mergeTag.description}
              primaryTypographyProps={{ fontWeight: 'bold' }}
              secondaryTypographyProps={{ sx: styles.itemDescription }}
            />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
